import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useGetAlertsQuery } from '#/services/developerApi';
import * as Styled from './styled';

function TripSummaryButton({
  fromAddress,
  toAddress,
  tripPlannerHandler,
  className,
}) {
  const { alertBannerIsVisible } = useSelector(s => s.user);
  const { data } = useGetAlertsQuery();
  const hasSystemWideAlert = data ? data.hasSystemWideAlert : false;
  return (
    <Styled.TripSummarySection
      hasSystemWideAlert={hasSystemWideAlert && alertBannerIsVisible}
      className={className}
    >
      <Styled.SummaryButton onClick={tripPlannerHandler}>
        <Styled.IconColumn>
          <Styled.OriginIcon />
        </Styled.IconColumn>
        <Styled.AddressColumn>
          <Styled.AddressText>{fromAddress}</Styled.AddressText>
        </Styled.AddressColumn>
        <Styled.IconColumn>
          <Styled.ChevronIcon />
        </Styled.IconColumn>
        <Styled.IconColumn>
          <Styled.DestinationIcon />
        </Styled.IconColumn>
        <Styled.AddressColumn>
          <Styled.AddressText>{toAddress}</Styled.AddressText>
        </Styled.AddressColumn>
      </Styled.SummaryButton>
    </Styled.TripSummarySection>
  );
}

TripSummaryButton.propTypes = {
  /** Origin Address of the Trip */
  fromAddress: PropTypes.string.isRequired,
  /** Destination Address of the Trip */
  toAddress: PropTypes.string.isRequired,
  /** Navigates to the Edit Trip Plan Page when triggered */
  tripPlannerHandler: PropTypes.func.isRequired,
  /** Pass-through for styled-components */
  className: PropTypes.string,
};

TripSummaryButton.defaultProps = {
  className: null,
};

export default TripSummaryButton;
